"use client"

import { supabaseClient } from "@/lib/supabase/client"

export async function getSiteInfoClient() {
  try {
    // Prioridade: 1) NEXT_PUBLIC_CASAMENTO_ID, 2) localStorage (admin), 3) default
    const casamentoId =
      process.env.NEXT_PUBLIC_CASAMENTO_ID ||
      (typeof window !== "undefined" ? localStorage.getItem("casamento_ativo_id") : null) ||
      "00000000-0000-0000-0000-000000000001"

    const { data } = await supabaseClient.from("site_info").select("*").eq("casamento_id", casamentoId)
    const safeData = Array.isArray(data) ? data : []

    if (safeData.length === 0) {
      return {
        nomeSite: "Noivos",
        corPrimaria: "#e4a99f",
        corSecundaria: "#f5f5f5",
        corTerciaria: "#333333",
        corQuaternaria: "#6c5ce7",
        dataCasamento: new Date().toISOString(),
        localCerimonia: "Local da Cerimônia",
        localRecepcao: "Local da Recepção",
        pix_chave: "",
        pix_texto: "Caso prefira, você pode nos presentear com uma contribuição via PIX.",
        nomeNoiva: "",
        nomeNoivo: "",
      }
    }

    // Converter o array de objetos em um único objeto
    const siteInfo: Record<string, string> = {}
    safeData.forEach((item) => {
      siteInfo[item.chave] = item.valor
    })

    return {
      nomeSite: siteInfo.nome_site || "Noivos",
      corPrimaria: siteInfo.cor_primaria || "#e4a99f",
      corSecundaria: siteInfo.cor_secundaria || "#f5f5f5",
      corTerciaria: siteInfo.cor_terciaria || "#333333",
      corQuaternaria: siteInfo.cor_quaternaria || "#6c5ce7",
      dataCasamento: siteInfo.data_casamento || new Date().toISOString(),
      localCerimonia: siteInfo.local_cerimonia || "Local da Cerimônia",
      localRecepcao: siteInfo.local_recepcao || "Local da Recepção",
      pix_chave: siteInfo.pix_chave || "",
      pix_texto: siteInfo.pix_texto || "Caso prefira, você pode nos presentear com uma contribuição via PIX.",
      nomeNoiva: siteInfo.nome_noiva || "",
      nomeNoivo: siteInfo.nome_noivo || "",
      urlsite: siteInfo.urlsite || ""
    }
  } catch (error) {
    console.error("Erro ao buscar informações do site:", error)
    return {
      nomeSite: "Noivos",
      corPrimaria: "#e4a99f",
      corSecundaria: "#f5f5f5",
      corTerciaria: "#333333",
      corQuaternaria: "#6c5ce7",
      dataCasamento: new Date().toISOString(),
      localCerimonia: "Local da Cerimônia",
      localRecepcao: "Local da Recepção",
      pix_chave: "",
      pix_texto: "Caso prefira, você pode nos presentear com uma contribuição via PIX.",
      nomeNoiva: "",
      nomeNoivo: "",
    }
  }
}

export async function getLogoImageClient() {
  try {
    const casamentoId = process.env.NEXT_PUBLIC_CASAMENTO_ID || '00000000-0000-0000-0000-000000000001'
    const { data } = await supabaseClient
      .from("imagens")
      .select("*")
      .eq("tipo", "logo")
      .eq("casamento_id", casamentoId)
      .maybeSingle()
    return data
  } catch (error) {
    console.error("Erro ao buscar logo:", error)
    return null
  }
}

export async function getFaviconClient() {
  try {
    const casamentoId = process.env.NEXT_PUBLIC_CASAMENTO_ID || '00000000-0000-0000-0000-000000000001'
    const { data } = await supabaseClient
      .from("imagens")
      .select("*")
      .eq("tipo", "favicon")
      .eq("casamento_id", casamentoId)
      .maybeSingle()
    return data?.url || "/favicon.ico"
  } catch (error) {
    console.error("Erro ao buscar favicon:", error)
    return "/favicon.ico"
  }
}
